var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnSeeMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 25,
    viewBox: "0 0 58 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 24,
    rx: 7.5,
    fill: "white",
    stroke: "#477AE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5241 17.888V7.136H15.5401V17.888H16.5241ZM11.5561 10.412V9.044H14.0881V8.228H8.07608V9.044H10.5721V10.412C10.5721 12.272 9.26408 14.288 7.71608 15.032L8.29208 15.824C9.49208 15.224 10.5841 13.832 11.0641 12.272C11.5801 13.748 12.6361 14.984 13.8841 15.56L14.4361 14.768C12.8521 14.096 11.5561 12.236 11.5561 10.412ZM27.5231 16.532V15.716H23.1191V12.956H26.3951V12.164H19.9751V8.792H26.2871V7.988H18.9911V12.956H22.1231V15.716H17.7431V16.532H27.5231ZM39.2338 16.508V15.704H34.8418V13.388H38.0578V7.892H37.0978V9.812H31.6018V7.892H30.6298V13.388H33.8458V15.704H29.4778V16.508H39.2338ZM37.0978 12.596H31.6018V10.616H37.0978V12.596ZM48.3489 17.888V7.124H47.3649V17.888H48.3489ZM45.1929 8.288H40.1529V9.08H44.1969C43.9929 11.636 42.5529 13.7 39.6609 15.08L40.1889 15.884C43.7769 14.12 45.1929 11.396 45.1929 8.288Z",
    fill: "#477AE9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSeeMap);
export default __webpack_public_path__ + "static/media/btnSeeMap.c5ba84261a89397d6f72cd8c3ba65cd2.svg";
export { ForwardRef as ReactComponent };